module.exports = __webpack_public_path__ + "img/valorisation.17c8da8d.jpg";